import { track } from '@vercel/analytics';

export const initAnalytics = () => true;

export const trackPageView = (path) => {
  track('page_view', {
    path,
  });
};

export const trackEvent = (eventName, params = {}) => {
  track(eventName, params);
};